module.exports = __webpack_public_path__ + "static/media/08_CORTININHA_SEM_BOJO_ESTAMPADO_01.12fc8577.jpg";